import { h } from '@stencil/core';
export class aibaVtoStyleComponent {
  constructor() {
    this.moreStyles = [];
    this.getVtoTabData = async () => {
      const data = await this.handlers.getVtoStyleStateData();
      if (Object.keys(data === null || data === void 0 ? void 0 : data.recommendedStyles).length > 0)
        return Object.keys(data === null || data === void 0 ? void 0 : data.recommendedStyles).reduce((total, curr) => {
          var _a;
          const tabTitle = (data === null || data === void 0 ? void 0 : data.styleTitle[curr]) ? data === null || data === void 0 ? void 0 : data.styleTitle[curr] : curr;
          const tabcontent = (_a = data === null || data === void 0 ? void 0 : data.recommendedStyles) === null || _a === void 0 ? void 0 : _a[curr].map((style, index) => {
            const styleInfo = Object.assign({}, style);
            if (index === 1 && curr === Object.keys(data === null || data === void 0 ? void 0 : data.styleTitle)[0]) {
              this.defaultStyle = styleInfo;
            }
            return (h("div", { key: index }, h("button", { ref: el => {
                if (index === 1 && curr === Object.keys(data === null || data === void 0 ? void 0 : data.styleTitle)[0]) {
                  this.vtoDefaultStyle = el;
                }
              }, class: `styles ${styleInfo.style === 'No Style' ? 'original' : ''}  ${styleInfo.style === 'View more' ? 'view-more' : ''} `, id: index === 1 ? 'defaultStyle ' : '', "data-style": styleInfo.style, "data-id": styleInfo.id, onClick: event => this.clickHandler(styleInfo.style, event, styleInfo.id, curr) }, h("img", { src: styleInfo.styleimageurl, alt: styleInfo.style, class: styleInfo.style === 'No Style' ? 'originalimg' : '' })), h("div", { class: "styletitle" }, data.styleContent[styleInfo.id])));
          });
          total.push({
            title: tabTitle,
            content: tabcontent,
          });
          return total;
        }, []);
    };
    this.clickHandler = async (style, event, id, activeTab) => {
      this.disableBtn = false;
      if (id === 'original') {
        this.disableBtn = true;
      }
      if (id === 'viewmore') {
        this.viewMoreStyles();
        return;
      }
      await this.handlers.setVtoHairStyle(style, event, id, activeTab, this.vtoBlock);
    };
    this.data = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.handleClick = undefined;
    this.vtoclass = 'showvto';
    this.defaultStyle = undefined;
    this.disableBtn = undefined;
    this.detailData = undefined;
    this.vtoDefaultStyle = undefined;
    this.vtoBlock = undefined;
    this.tabcontentdata = {};
    this.hideViewMore = undefined;
  }
  handletabLoaded() {
    //trigger click on tabcontent load
    console.log('tab loaded');
    // this.vtoDefaultStyle.click();
  }
  handlereadytogenerate() {
    //trigger click on tabcontent load
    console.log('vtoReadyToGenerate done');
    this.vtoDefaultStyle.click();
  }
  async componentWillLoad() {
    var _a, _b;
    this.detailData = await this.getVtoTabData();
    if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.hideViewMore) {
      this.hideViewMore = true;
    }
    else {
      this.hideViewMore = false;
    }
    if (!this.hideViewMore) {
      this.moreStyles = ((_b = this.detailData[1]) === null || _b === void 0 ? void 0 : _b.content.length) ? this.detailData[1].content : [];
      this.detailData.splice(1, 1);
    }
  }
  async componentDidLoad() {
    var _a, _b;
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.vtoStyleWrapperDidLoad)) {
      (_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.vtoStyleWrapperDidLoad();
    }
  }
  async componentDidRender() {
    var _a, _b;
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.vtoStyleWrapperDidRender)) {
      (_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.vtoStyleWrapperDidRender();
    }
  }
  viewMoreStyles() {
    var _a, _b;
    this.detailData[0].content.splice(this.detailData[0].content.length - 1, 1);
    this.detailData[0].content = [...this.detailData[0].content, ...this.moreStyles];
    this.detailData = [...this.detailData];
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.viewMoreClickHandler)) {
      (_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.viewMoreClickHandler();
    }
  }
  render() {
    var _a, _b;
    return (h("div", { class: this.vtoclass, ref: el => (this.vtoBlock = el) }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map(element => {
        if ((element === null || element === void 0 ? void 0 : element.name) === 'vto-tab-container') {
          return (h("div", { class: "tabcontainer" }, h("aiba-tab-list", { detailArray: this.detailData, activeTabHandler: event => { var _a; return this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.activeTabhandler(event)); } })));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-button') {
          return h("aiba-button", Object.assign({}, element.data, { handleClick: event => this.handlers.getVtoReccomendations(event, ''), disabled: this.disableBtn }));
        }
      })), h("div", { id: "vtooverlay" })));
  }
  static get is() { return "aiba-vto-style-wrapper"; }
  static get originalStyleUrls() {
    return {
      "$": ["./aiba-vto-style-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-vto-style-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "vtoclass": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vtoclass",
        "reflect": false,
        "defaultValue": "'showvto'"
      }
    };
  }
  static get states() {
    return {
      "defaultStyle": {},
      "disableBtn": {},
      "detailData": {},
      "vtoDefaultStyle": {},
      "vtoBlock": {},
      "tabcontentdata": {},
      "hideViewMore": {}
    };
  }
  static get listeners() {
    return [{
        "name": "tabLoaded",
        "method": "handletabLoaded",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "vtoReadyToGenerate",
        "method": "handlereadytogenerate",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-vto-style-wrapper.js.map
